<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4">
        <h2 class="text-center text-xl font-semibold">
          {{ title || item?.title || 'فرم تماس' }}
        </h2>
        <p
          v-if="subtitle"
          class="text-center text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <div
          v-if="!formId || builderPreview"
          class="rounded-2xl border border-dashed p-6 text-center text-sm text-muted"
        >
          فرم هوشمند تماس
        </div>
        <form
          v-else
          class="space-y-3"
          @submit.prevent="submit"
        >
          <UFormField label="نام">
            <UInput v-model="name" />
          </UFormField>
          <AuthPhoneInput v-model="phone" />
          <LeadQuestionFields
            v-model="answers"
            :questions="item?.questions ?? []"
          />
          <UButton
            type="submit"
            block
            class="min-h-11"
            :loading="saving"
            :disabled="!canSubmit"
          >
            ارسال
          </UButton>
        </form>
        <p
          v-if="done"
          class="text-center text-sm text-primary"
        >
          پیام شما ثبت شد.
        </p>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import type { LeadQuestion } from '~/utils/leads/questions'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  formId?: string
  builderPreview?: boolean
}>()

const item = ref<{ title: string; questions: LeadQuestion[] } | null>(null)
const name = ref('')
const phone = ref('')
const answers = ref<Record<string, unknown>>({})
const saving = ref(false)
const done = ref(false)
const error = ref('')
const canSubmit = computed(() => !props.builderPreview && isCompleteIrMobile(phone.value) && name.value.trim().length >= 2)

if (import.meta.client && props.formId && !props.builderPreview) {
  $fetch<{ item: NonNullable<typeof item.value> }>(`/api/leads/forms/${props.formId}`)
    .then((res) => { item.value = res.item })
    .catch(() => {})
}

async function submit() {
  if (!canSubmit.value || !props.formId) return
  saving.value = true
  error.value = ''
  try {
    await $fetch(`/api/leads/forms/${props.formId}/submit`, {
      method: 'POST',
      body: { name: name.value, phone: phone.value, answers: answers.value },
    })
    done.value = true
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ارسال ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
